import React from 'react';
import PropTypes from 'prop-types';
import styles from './QuestionDisplay.scss';
import themeServices from '../../themes/ThemeServices';
import uiService from '../../services/UIService';
import { removeEmptyTagsFromHTMLString } from '../../loading/utils/richTextUtils';
import questionReader from '../../store/readHelpers/QuestionReader';
import settingsReader from '../../store/readHelpers/SettingsReader';

class QuestionRubricBlock extends React.PureComponent {
    static propTypes = {
        question: PropTypes.object,
        choiceModel: PropTypes.object,
        hidePbBasedRubric: PropTypes.bool,
    };

    renderRubricContent(parsedHtml, className) {
        const { question } = this.props;
        return (
            <section
                tabIndex={0}
                aria-label={`questionRubricInstructions-${question.id}`}
                className={className}
                id="questionRubric"
            >
                <div
                    dangerouslySetInnerHTML={{ __html: parsedHtml }}
                />
            </section>
        );
    }

    render() {
        const { question, choiceModel, hidePbBasedRubric } = this.props;
        const hasWordFormationMetadata = settingsReader.shouldUsePaperBasedWordFormation(question);

        const questionRubricHTML = themeServices.getThemeInstance().getQuestionRubricsContent(question, choiceModel);

        if (!questionRubricHTML) {
            return null;
        }

        const parsedHtml = removeEmptyTagsFromHTMLString(questionRubricHTML);

        if (uiService.isPaperBasedRenderForCEQ()) {
            if (
                (hidePbBasedRubric || !questionReader.isFirstQuestionInSection(question))
            ) {
                return null;
            }
            return (
                <div>
                    {this.renderRubricContent(parsedHtml, styles.pbBasedRubricContent)}
                    {!hasWordFormationMetadata && (
                        <div className={styles.pbBasedDrawingSeparator} />
                    )}
                </div>
            );
        }
        return this.renderRubricContent(parsedHtml, styles.rubricContent);
    }
}

export default QuestionRubricBlock;
